<template lang="jade">
  tr.Datagrid__row(v-bind:class="{'Datagrid__row--odd': !(index % 2)}")
    td.Datagrid__cell(v-for="cell in vCells"
                      track-by="$index"
                      class="animated"
                      transition="fade")
      component(v-if="cell.isWidget"
                ":is"="cell.type"
                ":template"="columns[$index].template"
                ":dataset"="cell")
      partial(v-else
              ":name"="cell.type")
  tr.Datagrid__row(v-if="expanded"
                   class="Datagrid__row--expanded")
    td.Datagrid__cell(":colspan"="columns.length"
                      class="Datagrid__cell--expanded")
      div.Tags
        div.Tag(v-for="item in additional")
          span.Tag__label {{ item.label }}
          span.Tag__text {{ item.value }}
</template>

<script>
import { DataTable } from 'src/services/resources'
import {expander, html} from './_shared/partials'
import { table, forms } from 'src/vuex/getters'
import _ from 'lodash'

export default {
  data () {
    return {
      uid: this.$parent.uid,
      savelistId: this.$parent.savelistId,
      expanded: false,
      additional: []
    }
  },
  vuex: {
    getters: {
      table,
      forms
    }
  },
  props: {
    cells: {
      type: Array,
      required: true
    },
    columns: {
      type: Array
    },
    index: {
      type: Number,
      required: true
    }
  },
  components: {
    widget: require('./cells/widget'),
    expander: require('./cells/expander'),
    html: require('./cells/html'),
    link: require('./cells/link')
  },
  partials: {
    expander,
    html
  },
  computed: {
    form () {
      return _.find(this.forms, ['uid', this.uid])
    },

    headers () {
      return {
        headers: {
          'X-FINGERPRINT': this.form.fingerprint,
          'X-SITEID': this.form.siteid
        }
      }
    },

    vCells () {
      let cols = this.columns
      let [cells] = this.cells.reduce((acc, xs, i) => {
        let column = acc[1][i]
        if (column.visible) {
          let cell = typeof xs === 'string' ? { val: xs } : xs
          _.head(acc).push(Object.assign({}, cell, {
            cid: column.id,
            isWidget: column.isWidget,
            type: column.type
          }))
        }
        return acc
      }, [[], cols])
      return cells
    }
  },
  methods: {
    expand (key, index, row) {
      if (this.additional.length) {
        this.$set('expanded', !this.expanded)
      } else {
        this.fetchExpanderData(key)
      }
    },

    fetchExpanderData (key) {
      let params = {
        siteId: this.siteid,
        savelistId: this.savelistId,
        key: key
      }
      DataTable.expander(params, this.headers)
        .then(res => {
          let data = res.data.content.body[0].content[0].content.map(xs => {
            return { label: xs.label, value: xs.value }
          })
          this.$set('additional', data)
          this.$set('expanded', true)
        })
        .catch(response => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// rows.vue?f4367e54